import React, { useState, useEffect, useContext } from 'react';
import './style.css';
import { WindowSizeContext, AddressSearchContext } from '/src/App';
import CreateCloudfrontUrl from '/src/services/CreateCloudfrontUrl';
import HelmetProvider from '/src/Components/HelmetProvider/HelmetProvider';
import AddressSearch from '/src/Components/AddressSearch/AddressSearch';
import DynamicWhatWeDo from '/src/Components/DynamicWhatWeDo/DynamicWhatWeDo';
import ImageModal from '/src/Components/ImageModal/ImageModal';
import GetWhatsInAnalysisData from '/src/services/Content/GetWhatsInAnalysisData';
import SectionDivider from '/src/Components/SectionDivider/SectionDivider';
import MyAccountIconDark from '/src/assets/scenarios-icon-dark.svg';
import MyAccountIconLight from '/src/assets/scenarios-icon-light.svg';
import greenDot from '/src/assets/Green-Dot-4.svg';
import { Redo, MoveLeft } from 'lucide-react';
import StandardButton from '/src/Components/StandardButton/StandardButton';


const WhatsInEachAnalysis = () => {
    const { deviceType } = useContext(WindowSizeContext);

    // Get combined data
    const analysisData = GetWhatsInAnalysisData();

    // State management
    const [activeSection, setActiveSection] = useState(1); // Start with stage 1
    const [selectedImageIndex, setSelectedImageIndex] = useState(null);
    const [modalImages, setModalImages] = useState([]);
    const [pageHeaderHeightOffset, setPageHeaderHeightOffset] = useState(0);

    // Get the height of the page 
    useEffect(() => {
        const pageHeader = document.querySelector('.page-header-container');
        let gapToAddInPx = 10;
        if (deviceType === 'mobile') {
            gapToAddInPx = 0;
        }
        setPageHeaderHeightOffset(pageHeader.offsetHeight + gapToAddInPx);
        // if (deviceType === 'desktop' || deviceType === 'tablet') {
        //     setPageHeaderHeightOffset(pageHeader.offsetHeight + gapToAddInPx);
        // } else {
        //     setPageHeaderHeightOffset(0);
        // }
    }, [deviceType]);

    const title = "What You'll See When You Search An Address";
    const introText = "Learning how climate change translates to your home and wallet can be a lot to take in! We’ll walk you through the entire story, connecting the dots so you won’t just feel clear on what you’re up against, you’ll be empowered to act!";

    // Get current section data
    const currentSectionData = analysisData.find(section => section.stage === activeSection);

    // Handle thumbnail click
    const handleThumbnailClick = (images, index) => {
        setModalImages(images);
        setSelectedImageIndex(index);
    };

    // Modal navigation handlers
    const handleModalClose = () => {
        setSelectedImageIndex(null);
        setModalImages([]);
    };

    const handleModalNext = () => {
        if (selectedImageIndex < modalImages.length - 1) {
            setSelectedImageIndex(selectedImageIndex + 1);
        }
    };

    const handleModalPrev = () => {
        if (selectedImageIndex > 0) {
            setSelectedImageIndex(selectedImageIndex - 1);
        }
    };

    const dividerType = "cross-out-underline";
    const dividerColor = "green";

    const bottomSectionHeadline = "It's Okay To Feel Overwhelmed"
    const bottomSectionText = "Our goal is not to overload you with data and have you immediately jump all the way to the end. That's why we've added tools to help you work this through. Play with our assumptions to tailor this to your own family situation, test out different scenarios, and do whatever is going to help you feel empowered to protect your future."

    const buttonsArray = [
        {
            text: "Why is Quoll Free?",
            link: "/about/why-is-quoll-free"
        },
        {
            text: "Guides and Resources",
            link: "/resources"
        }
    ]

    const renderCalloutButton = () => {
        return (
            <div className={`whats-in-analysis-bottom-section-button-content ${deviceType}`}>
                <div className={`whats-in-analysis-bottom-section-button-container ${deviceType}`}>
                    <div className={`whats-in-analysis-bottom-section-button-container-background`}>
                        <img src={greenDot} alt="green dot" />
                    </div>
                    <div className="whats-in-analysis-bottom-section-button-icon-container">
                        <img className={`whats-in-analysis-bottom-section-button-icon`} src={MyAccountIconLight} alt="Quoll Refine Analysis Icon" />
                    </div>
                </div>
                <div className={`whats-in-analysis-bottom-section-button-text-arrow-container ${deviceType}`}>
                    {deviceType === 'mobile' ? <MoveLeft className={`whats-in-analysis-bottom-section-button-text-arrow ${deviceType}`} /> : <Redo className={`whats-in-analysis-bottom-section-button-text-arrow ${deviceType}`} />}
                    <span className={`whats-in-analysis-bottom-section-button-text-arrow-text ${deviceType}`}>Look for this symbol!</span>
                </div>
            </div>
        )
    }

    return (
        <>
            <HelmetProvider pageType="whatIsQuoll" />

            <div className="static-page-content-frame">
                {/* Header Section */}
                <div className="what-is-quoll-section-container">
                    <div className={`whats-in-analysis-header ${deviceType}`}>
                        <h1>{title}</h1>
                        {/* <p dangerouslySetInnerHTML={{ __html: introText }} /> */}
                    </div>
                    {/* <SectionDivider type={dividerType} color={dividerColor} /> */}

                    {/* Two-Column Layout */}
                    <div className={`whats-in-analysis-container ${deviceType}`}>
                        {/* Left Navigation Column (Sticky) */}
                        <div className={` whats-in-analysis-nav ${deviceType} `} style={{ top: `${pageHeaderHeightOffset}px` }}>
                            <div className="whats-in-analysis-content-container">
                                {/* House Image */}
                                <div className="whats-in-analysis-nav-house">

                                    <div className="whats-in-analysis-house-image-wrapper">
                                        <img
                                            src={CreateCloudfrontUrl("home-good-condition.png")}
                                            alt="Your House"
                                            className="whats-in-analysis-house-image"
                                        />
                                        <div className="whats-in-analysis-house-address-overlay">
                                            123 Main Street
                                        </div>
                                    </div>
                                </div>

                                {/* Navigation Buttons */}
                                <div className={`whats-in-analysis-nav-buttons ${deviceType}`}>
                                    {analysisData.map((section, index) => (
                                        <button
                                            key={section.stage}
                                            className={`whats-in-analysis-nav-button ${activeSection === section.stage ? 'active' : ''} ${deviceType}`}
                                            onClick={() => setActiveSection(section.stage)}
                                        >
                                            <span className={`nav-button-icon ${deviceType}`}>
                                                {/* Icon placeholder - can add icons later */}
                                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2" />
                                                    <path d="M8 12L11 15L16 9" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                                </svg>
                                            </span>
                                            <span className={`nav-button-text ${deviceType}`}>
                                                {section.title}
                                            </span>
                                        </button>
                                    ))}
                                </div>

                                {/* Search Section */}
                                {/* <div className="whats-in-analysis-nav-search">
                                <h3>Ready to get started?</h3>
                                <AddressSearch />
                            </div> */}
                            </div>
                        </div>

                        {/* Right Content Column (Scrollable) */}
                        <div className={`whats-in-analysis-content ${deviceType}`}>
                            {currentSectionData && (
                                <>
                                    {/* Section Header */}
                                    <div className="whats-in-analysis-section-header">
                                        <h2>{currentSectionData.title}</h2>
                                        <p dangerouslySetInnerHTML={{ __html: currentSectionData.content }} />
                                    </div>

                                    {/* Dynamic Visualization */}
                                    <div className={`whats-in-analysis-visualization ${deviceType}`}>
                                        <DynamicWhatWeDo
                                            currentSection={currentSectionData.stage}
                                            sections={analysisData}
                                        />
                                    </div>

                                    {/* Product Images */}
                                    {currentSectionData.productImages && currentSectionData.productImages.length > 0 && (
                                        <div className="whats-in-analysis-product-images">
                                            {/* <h3>What You'll See</h3> */}
                                            <div className="product-images-grid">
                                                {currentSectionData.productImages.map((image, index) => (
                                                    <div
                                                        key={index}
                                                        className="product-image-thumbnail"
                                                        onClick={() => handleThumbnailClick(currentSectionData.productImages, index)}
                                                    >
                                                        <img
                                                            src={CreateCloudfrontUrl(image.image)}
                                                            alt={image.alt}
                                                        />
                                                        {/* <p>{image.alt}</p> */}
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    )}
                                </>
                            )}
                        </div>
                    </div>
                </div>
                <div className="what-is-quoll-section-container">
                    <h2>{bottomSectionHeadline}</h2>
                    <div className={`whats-in-analysis-personalize-content ${deviceType}`}>

                        {deviceType !== 'mobile' && (
                            renderCalloutButton()
                        )}
                        {/* <div className={`whats-in-analysis-bottom-section-button-content ${deviceType}`}>
                            <div className={`whats-in-analysis-bottom-section-button-container ${deviceType}`}>
                                <div className={`whats-in-analysis-bottom-section-button-container-background`}>
                                    <img src={greenDot} alt="green dot" />
                                </div>
                                <div className="whats-in-analysis-bottom-section-button-icon-container">
                                    <img className={`whats-in-analysis-bottom-section-button-icon`} src={MyAccountIconLight} alt="Quoll Refine Analysis Icon" />
                                </div>
                            </div>
                            <div className={`whats-in-analysis-bottom-section-button-text-arrow-container ${deviceType}`}>
                                {deviceType === 'mobile' ? <MoveLeft className={`whats-in-analysis-bottom-section-button-text-arrow ${deviceType}`} /> : <Redo className={`whats-in-analysis-bottom-section-button-text-arrow ${deviceType}`} />}
                                <span className={`whats-in-analysis-bottom-section-button-text-arrow-text ${deviceType}`}>Look for this symbol!</span>
                            </div>
                        </div> */}
                        <p className="whats-in-analysis-bottom-section-text" dangerouslySetInnerHTML={{ __html: bottomSectionText }} />
                        {deviceType === 'mobile' && (
                            renderCalloutButton()
                        )}
                    </div>
                    <div className={`meet-quoll-button-links ${deviceType}`}>
                        {buttonsArray.map((button, index) => (
                            <StandardButton
                                id={`whats-in-analysis-button-${index}`}
                                text={button.text}
                                link={button.link}
                            />
                        ))}
                    </div>
                </div>

                {/* Image Modal */}
                {selectedImageIndex !== null && (
                    <ImageModal
                        images={modalImages}
                        currentIndex={selectedImageIndex}
                        onClose={handleModalClose}
                        onNext={handleModalNext}
                        onPrev={handleModalPrev}
                    />
                )}
            </div >
        </>
    );
};

export default WhatsInEachAnalysis;